import store from "./index";

const getters = {
  empCode: state => state.user.empCode,
  name: state => state.user.name,
  token: state => state.user.token,
  center: state => state.user.center,
  departName: state => state.user.departName,
  cityCode: state => state.user.cityCode,
  collapsed: state => state.app.collapsed,
  collapsedbar: state => state.app.collapsedbar,

  addRouters: state => state.permission.addRouters,
  menuList: state => state.permission.menuList,
  routers: state => state.permission.routers,
  apiList: state => state.permission.apiList,
  projectList:state => state.user.projectList,
  source:state=>state.request.source,
  projectListByCondiction:state => state.user.projectListByCondiction,
  authCity:state => state.user.authCity
};
export default getters;
